// script.js
import $ from "jquery";
$(function () {
  $(".mobile-menu").map(function (e) {
    const firstDiv = $(this).find("div").first();
    console.log(firstDiv);

    // for each [data-next]
    $(this)
      .find("[data-next]")
      .map(function (e) {
        // parent, then find [data-next-content], then first
        const content = $(this).parent().find("[data-next-content]").first();
        // save content to variable and remove from dom
        const contentClone = content.clone();
        content.remove();

        // button
        const menuButton = $(this);
        menuButton.on("click", function () {
          const insertedContent = contentClone.clone();
          // insert contentClone after firstDiv
          // create new button that cleans up the dom
          // insert ad the beginning of the insertedContent a button
          const button = $("<button class='border-0 bg-transparent px-0 text-secondary fs-4 fw-bolder mb-2 text-start d-flex gap-2 align-items-center text-uppercase'>");
          const svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M6 1C4.04738 2.95262 2.95262 4.04738 1 6L6 11" stroke="#FF6328" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
          button.html(`${svgIcon} ${menuButton.text()}`);
          button.on("click", function () {
            insertedContent.remove();
            firstDiv.show();
          });
          insertedContent.prepend(button);
          firstDiv.after(insertedContent);
          firstDiv.hide();
        });
      });
  });

  $('#mobile-menu').on('show.bs.modal', function () {
    $('#page').removeClass('sticky-top');
  });

  // When the modal has finished being hidden
  $('#mobile-menu').on('hidden.bs.modal', function () {
      $('#page').addClass('sticky-top');
  });
});
